import styled from "styled-components";

export const LayoutWrapper = styled.div`
  min-height: 100vh;
`;
